'use strict';

import Styles from './less/core.less';

import 'lazysizes/plugins/object-fit/ls.object-fit';
import 'lazysizes/plugins/bgset/ls.bgset';
import 'lazysizes/plugins/respimg/ls.respimg';
import 'lazysizes/plugins/parent-fit/ls.parent-fit';
import 'lazysizes';



// WEBPACK FOOTER //
// ./app/components/responsive-images/main.js